(function () {
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

  function initContactForm() {
    const forms = document.querySelectorAll('.contact-form__form');

    forms.forEach(function (form) {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';

      const isValidEmail = function (email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      };

      const validateForm = function () {
        const requiredFields = form.querySelectorAll('[aria-required="true"], [required]');
        let hasError = false;
        let firstInvalidField = null;

        requiredFields.forEach(function (field) {
          const container = field.closest('.contact-form__input-container');
          const existingError = container?.querySelector('.contact-form__field-error');
          const fieldValue = (field.value || '').trim();
          const isEmailField = field.type === 'email' || field.getAttribute('name')?.toLowerCase() === 'email';
          let fieldError = false;
          let errorMessage = 'This is a compulsory field';

          if (!fieldValue) {
            fieldError = true;
          } else if (isEmailField && !isValidEmail(fieldValue)) {
            fieldError = true;
            errorMessage = 'Please enter a valid email address';
          }

          if (fieldError) {
            hasError = true;

            if (!firstInvalidField) {
              firstInvalidField = field;
            }

            if (existingError) {
              existingError.remove();
            }

            if (container) {
              container.classList.add('contact-form__input-container--error');
            }

            const errorDiv = document.createElement('div');
            errorDiv.className = 'contact-form__field-error';
            errorDiv.id = field.id + '-error';
            errorDiv.textContent = errorMessage;
            errorDiv.setAttribute('role', 'alert');
            field.setAttribute('aria-invalid', 'true');
            field.setAttribute('aria-describedby', errorDiv.id);

            if (container) {
              container.appendChild(errorDiv);
            }
          } else {
            if (existingError) {
              existingError.remove();
            }
            if (container) {
              container.classList.remove('contact-form__input-container--error');
            }
            field.removeAttribute('aria-invalid');
            const describedBy = field.getAttribute('aria-describedby');
            if (describedBy && describedBy === field.id + '-error') {
              field.removeAttribute('aria-describedby');
            }
          }
        });

        return { hasError: hasError, firstInvalidField: firstInvalidField };
      };

      const handleSubmit = function (event) {
        event.preventDefault();
        event.stopPropagation();

        const validation = validateForm();

        if (validation.hasError) {
          if (validation.firstInvalidField) {
            validation.firstInvalidField.focus();
          }
          return false;
        }

        form.removeEventListener('submit', handleSubmit);
        form.submit();
      };

      form.addEventListener('submit', handleSubmit);

      const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])');
      submitButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          const validation = validateForm();
          if (validation.hasError) {
            event.preventDefault();
            event.stopPropagation();
            if (validation.firstInvalidField) {
              validation.firstInvalidField.focus();
            }
          }
        });
      });

      const inputs = form.querySelectorAll('.contact-form__input');
      inputs.forEach(function (input) {
        input.addEventListener(
          'input',
          debounce(function () {
            const container = this.closest('.contact-form__input-container');
            const error = container?.querySelector('.contact-form__field-error');
            const fieldValue = this.value ? this.value.trim() : '';
            const isEmailField = this.type === 'email' || this.getAttribute('name')?.toLowerCase() === 'email';
            const isValid = fieldValue && (!isEmailField || isValidEmail(fieldValue));

            if (error && isValid) {
              error.remove();
              if (container) {
                container.classList.remove('contact-form__input-container--error');
              }
              this.removeAttribute('aria-invalid');
              this.removeAttribute('aria-describedby');
            }
          }, 150)
        );
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactForm);
  } else {
    initContactForm();
  }

  if (typeof window !== 'undefined') {
    window.initContactForm = initContactForm;
  }
})();
